module.exports = __webpack_public_path__ + "static/media/2. Colgante N1. Superficie sólida. 120 x 45 x 20 cm. 2020 copy.248a86e4.png";